import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import {
  FontAwesomeIcon,
  CATEGORIES,
} from '@hivebrite/design-system/FontAwesomeIcon';

const MediaUploadError = ({ error }: { error: string }) => {
  if (!error) {
    return null;
  }

  return (
    <ErrorOverlay title={error}>
      <IconBg>
        <FontAwesomeIcon
          color="fire"
          height="32px"
          iconName="circle-exclamation"
          iconType={CATEGORIES.SOLID}
        />
      </IconBg>
    </ErrorOverlay>
  );
};

export default MediaUploadError;

const ErrorOverlay = styled(Box).attrs(() => ({
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  minWidth: '75px',
  minHeight: '75px',
  alignItems: 'center',
  justifyContent: 'center',
  bg: 'rgba(0, 0, 0, 0.4)',
}))`
  border-radius: ${({ theme }) => theme.themeVariables.globalBorderRadius}px;
`;

const IconBg = styled(Box)`
  border-radius: 50%;
  background-color: white;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
`;
